var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 112,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 112,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M8.934 28c.468.052.858.052 1.378.052 2.158 0 4.108-.936 4.108-4.576V9.8h-2.86v13.884c0 1.404-.728 1.742-1.638 1.742-.312 0-.676 0-.988-.026V28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M7.553 42.266c-1.182 1.312-1.182 3.439 0 4.75.882.978 2.172 1.227 3.262.747v2.904h2.37v-2.904c1.09.48 2.38.231 3.261-.747 1.183-1.311 1.183-3.438 0-4.75L12 37.333l-4.447 4.933ZM33.33 53.4c-1.773 1.967-1.773 5.157 0 7.124 1.323 1.468 3.258 1.84 4.892 1.12V66h3.556v-4.356c1.634.72 3.57.348 4.892-1.12 1.773-1.967 1.773-5.157 0-7.125L40 46l-6.67 7.4Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    d: "M71.066 84c-.468-.052-.858-.052-1.378-.052-2.158 0-4.108.936-4.108 4.576V102.2h2.86V88.316c0-1.404.728-1.742 1.638-1.742.312 0 .676 0 .988.026V84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C2833",
    fillRule: "evenodd",
    d: "M72.447 69.734c1.182-1.312 1.182-3.439 0-4.75-.882-.978-2.172-1.227-3.262-.746v-2.905h-2.37v2.904c-1.09-.48-2.38-.231-3.261.747-1.183 1.311-1.183 3.438 0 4.75L68 74.667l4.447-4.933Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.9ef42cc32f1d8885401a3e9b082d52b2.svg";
export { ForwardRef as ReactComponent };